/**
 * Notification context + hook. Kept apart from the provider component so the
 * component file only exports components (react-refresh).
 */
import * as React from 'react';
import type { NotificationScope } from './scope';
import type { AppNotification, NotificationStatus } from './types';

export interface NotificationsContextValue {
  /** Ordinary dashboard items (scope `account`, incl. the CP Hub summary). */
  notifications: AppNotification[];
  unreadCount: number;
  /** Channel Partner Hub items (scope `channel_partner`). */
  channelPartnerNotifications: AppNotification[];
  channelPartnerUnreadCount: number;
  status: NotificationStatus;
  markAsRead: (id: string) => void;
  markAllAsRead: (scope: NotificationScope) => void;
}

export const NotificationsContext = React.createContext<NotificationsContextValue | null>(null);

export function useNotifications(): NotificationsContextValue {
  const ctx = React.useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotifications must be used within <NotificationsProvider>');
  }
  return ctx;
}
